/**
 * @generated SignedSource<<79bbc56644786d710d2124332fc2dc3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RosterLoadMutationGroup",
    "kind": "LinkedField",
    "name": "rosterLoad",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "componentId",
                "variableName": "id"
              },
              {
                "kind": "Variable",
                "name": "status",
                "variableName": "status"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "RosterLoadComponentModifyPayload",
        "kind": "LinkedField",
        "name": "modifyRosterLoadComponent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RosterLoadComponent",
            "kind": "LinkedField",
            "name": "component",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptRejectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptRejectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "db5b017be9c38e9c30966db4f28880a0",
    "id": null,
    "metadata": {},
    "name": "AcceptRejectMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptRejectMutation(\n  $id: ID!\n  $status: String!\n) {\n  rosterLoad {\n    modifyRosterLoadComponent(input: {componentId: $id, status: $status}) {\n      component {\n        id\n        status\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "8a424ac0bc1028349e3dec5fc094d7cd";

export default node;
